module.exports = __webpack_public_path__ + "img/4.283ea981.png";